import React, { Component } from "react";

import "./style.css";

class Button extends Component {
	click = () => {
		const { onClick, href, newWindow, isSearchDisabled } = this.props;

		if (isSearchDisabled) return;

		if (href)
			if (newWindow) {
				window.open(href, "_blank");
			} else window.location.href = href;
		if (onClick) onClick();
	};

	render() {
		const { icon, text, isSearchDisabled, newWindow, ...props } = this.props;

		return (
			<div
				className={`button ${isSearchDisabled ? "disabled" : "white"}`}
				{...props}
				onClick={this.click}
			>
				{text}
			</div>
		);
	}
}

export default Button;
